module.exports = __webpack_public_path__ + "static/media/YF36_0.fcfb3069.jpg";